import { InvoicePaymentMethod, PaymentStatus } from "@/gql/graphql";

export const paymentMessages = {
  status: {
    [PaymentStatus.Paid]: "Paid",
    [PaymentStatus.PartiallyRefunded]: "Partially refunded",
    [PaymentStatus.Pending]: "Pending",
    [PaymentStatus.Refunded]: "Refunded",
    [PaymentStatus.Disputed]: "Charged back",
    [PaymentStatus.Unpaid]: "Unpaid",
    [PaymentStatus.Voided]: "Voided",
  },
  statusDescription: {
    [PaymentStatus.Paid]: "Charged to the customer's card.",
    [PaymentStatus.PartiallyRefunded]:
      "Charged to the customer's card, then part of it was refunded.",
    [PaymentStatus.Pending]:
      "A hold is on the customer's card. Nothing has been charged yet.",
    [PaymentStatus.Refunded]:
      "Charged to the customer's card, then refunded in full.",
    [PaymentStatus.Disputed]:
      "The customer charged this back with their bank. Stripe has withdrawn the funds.",
    [PaymentStatus.Unpaid]: "No money has been taken for this payment.",
    [PaymentStatus.Voided]:
      "A hold was placed on the customer's card and then cancelled. Nothing was charged.",
  },
  method: {
    [InvoicePaymentMethod.Stripe]: "Stripe",
    [InvoicePaymentMethod.DirectDeposit]: "Direct Deposit",
  },
  // Raw Stripe dispute statuses - warning_* are inquiries, no funds withdrawn
  disputeStatus: {
    warning_needs_response: "Inquiry — response needed",
    warning_under_review: "Inquiry — under review",
    warning_closed: "Inquiry closed",
    needs_response: "Chargeback — response needed",
    under_review: "Chargeback — under review",
    won: "Chargeback won",
    lost: "Chargeback lost",
  } as Record<string, string>,
};
